"use client";

import { useCallback, useState } from "react";
import styles from "../member.module.scss";
import type { Member } from "../_data/members";
import MemberCard from "./MemberCard";
import MemberPanel from "./MemberPanel";

type MemberSectionsProps = {
  members: Member[];
  partners: Member[];
};

function hasProfile(member: Member): boolean {
  return Boolean(member.career && member.career.length > 0);
}

export default function MemberSections({
  members,
  partners,
}: MemberSectionsProps) {
  const [selected, setSelected] = useState<Member | null>(null);
  const close = useCallback(() => setSelected(null), []);

  const renderGrid = (list: Member[], firstIsPriority: boolean) => (
    <div className={styles.cardGrid}>
      {list.map((member, index) => (
        <MemberCard
          key={member.name}
          member={member}
          onOpen={hasProfile(member) ? setSelected : undefined}
          priority={firstIsPriority && index === 0}
        />
      ))}
    </div>
  );

  return (
    <>
      <section className={styles.memberSection}>
        <h2 className={`${styles.sectionHead} fade-up`}>MEMBER</h2>
        {renderGrid(members, true)}
      </section>

      <section className={styles.partnerSection}>
        <h2 className={`${styles.sectionHead} fade-up`}>PARTNER</h2>
        {renderGrid(partners, false)}
      </section>

      <MemberPanel member={selected} onClose={close} />
    </>
  );
}
